import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Render an overlay over the entire page.
 *
 * @param {Renderable} [spec.contents] - Content diplayed in the overlay.
 */

/**
 * TODO: write documentation
 */
export default class PageOverlayWidget extends Widget {
	constructor({ contents, translucent = true }) {
		super(...arguments);
		this._contents = contents;
		this._translucent = translucent;
	}

	show() {
		this.appendTo("body");

		this.asJQuery()
			.find(".page-overlay")
			.removeClass("fade-out")
			.addClass("fade-in");
	}

	hide() {
		this.asJQuery()
			.find(".page-overlay")
			.removeClass("fade-in")
			.addClass("fade-out");

		setTimeout(() => {
			this.asJQuery().remove();
		}, 400);
	}

	renderContentOn(html) {
		html.div(
			{
				"data-test": "page-overlay",
				klass: ["page-overlay", { translucent: this._translucent }],
			},
			html.div({ klass: "contents" }, this._contents),
		);
	}
}
